import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { PageHeader } from "@shared/components/PageHeader";
import { Card } from "@shared/ui/card";
import { Gauge, Wrench } from "lucide-react";

export const TechnicalSpecifications = ({
  meterDetail,
}: {
  meterDetail: any;
}) => {
  const techSpecs = meterDetail?.meterModel?.technicalSpecifications;

  const specs = [
    {
      label: "Dial Length (mm)",
      value: techSpecs?.dialLength ?? "NA",
      tooltip: "The length of the meter dial display in millimeters",
    },
    {
      label: "Dial Count",
      value: techSpecs?.dialCount ?? "NA",
      tooltip: "Number of individual dials or digits on the meter display",
    },
    {
      label: "Max Flow (m³/h)",
      value: techSpecs?.maxFlow ?? "NA",
      tooltip:
        "Maximum flow rate the meter can accurately measure in cubic meters per hour",
    },
    {
      label: "Connection Size",
      value: techSpecs?.connectionSize ?? "NA",
      tooltip: "Standard pipe connection size for meter installation",
    },
    {
      label: "Meter Model",
      value: meterDetail?.meterModel?.meterModel ?? "NA",
      tooltip: "Manufacturer model designation",
    },
    {
      label: "Weight (kg)",
      value: techSpecs?.weight ?? "NA",
      tooltip: "Total weight of the meter unit in kilograms",
    },
    {
      label: "Accuracy",
      value: techSpecs?.accuracy ?? "NA",
      tooltip: "Measurement accuracy rating or tolerance level of the meter",
    },
    {
      label: "Length (mm)",
      value: techSpecs?.length ?? "NA",
      tooltip: "Overall length dimension of the meter body in millimeters",
    },
    {
      label: "Width (mm)",
      value: techSpecs?.width ?? "NA",
      tooltip: "Overall width dimension of the meter body in millimeters",
    },
    {
      label: "Height (mm)",
      value: techSpecs?.height ?? "NA",
      tooltip: "Overall height dimension of the meter body in millimeters",
    },
    {
      label: "Material",
      value: techSpecs?.material ?? "NA",
      tooltip: "Main construction materials of the meter",
    },
    {
      label: "IP Rating",
      value: techSpecs?.ipRating ?? "NA",
      tooltip:
        "Ingress Protection rating indicating resistance to dust and water",
    },
  ];

  return (
    <Card className="shadow-sm">
      <div className="space-y-6">
        <PageHeader
          title="Technical Specifications"
          subtitle="Deep hardware-level data for Supervisor decisions"
          icon={Wrench}
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {specs.map((spec) => (
            <ValueLabel
              key={spec.label}
              label={spec.label}
              value={spec.value}
              tooltip={spec.tooltip}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};
